import { Injectable } from "@angular/core";
import { combineEpics } from "redux-observable";
import { ContactEpics } from "../../+authenticated/+customer-master/customer-detail/contacts-v2/epics/contact-epics";
import { CustomerEpics } from "../../+authenticated/+customer-master/customer-detail/epics/customer-epics";
import { TechProfilesListEpics } from "../../+authenticated/+customer-master/customer-detail/tech-profiles/tech-profiles-list-epics";

@Injectable()
export class RootEpics {
    constructor(private customerEpics: CustomerEpics,
                private contactEpics: ContactEpics,
                private techProfilesListEpics: TechProfilesListEpics) {
    }

    public createEpics() {
        return combineEpics(
            this.customerEpics.getCustomerEpic,
            this.customerEpics.getCustomerSiblingsEpic,
            this.contactEpics.getContactEpic,
            this.contactEpics.createContactEpic,
            this.contactEpics.updateContactEpic,
            this.techProfilesListEpics.getTechProfilesListEpic,
            this.techProfilesListEpics.deleteTechProfilesEpic,
            this.techProfilesListEpics.getTechProfilesAppliesToFilterListEpic,
        );
    }
}
